import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { offline } from '@redux-offline/redux-offline';
import offlineConfig from '@redux-offline/redux-offline/lib/defaults';
import { autoRehydrate } from 'redux-persist';
import { logger } from 'redux-logger';
import { cmsApp } from './reducers';
import delay from "./delayRendering";
const configureStore = () => {
  let middlewares = [thunk, ];
  if(process.env.NODE_ENV === 'development'){
    middlewares.push(logger);
  }

  const store = createStore(
    cmsApp,
    {},
    compose(
      applyMiddleware(...middlewares),
      offline({
        ...offlineConfig,
        persistCallback: () => delay(store),
        persistAutoRehydrate: () => autoRehydrate({log: process.env.NODE_ENV === 'development'?true:false}),
        persistOptions: {
          blacklist: ['isHydrated', 'isFetchingList', 'error']
        }
      })
    )
  );
  return store;
};

export default configureStore;


// WEBPACK FOOTER //
// ./src/configureStore.js